import { Controller } from "@hotwired/stimulus"
import "bootstrap-tagsinput"

export default class TagsInputController extends Controller {
    connect() {
        $('.tag-input').tagsinput({
        });
    }
}